module.exports = __webpack_public_path__ + "img/logo8.36665728.png";